<template>
	<ul :class="componentClass">
		<li>
			<a href="https://www.facebook.com/iuspopuli" target="_blank">
        <i class="fa fa-facebook"></i>
      </a>
		</li>
		<!-- <li>
			<a href="#"><i class="fa fa-google-plus"></i></a>
		</li> -->
		<!-- <li>
			<a href="#"><i class="fa fa-twitter"></i></a>
		</li> -->
		<li>
			<a href="https://www.linkedin.com/company/iuspopuli" target="_blank">
        <i class="fa fa-linkedin"></i>
      </a>
		</li>
		<!-- <li>
			<a href="#"><i class="fa fa-pinterest-p"></i></a>
		</li> -->
	</ul>
</template>

<script>
export default {
	name: 'SocialsLinks',
	props: {
		componentClass: {
			type: String,
			default: 'list-none',
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/partials/SocialsLinks.vue